var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
/**
 * Moves the item at index from to index to. Returns a new instance of the array with the item
 * moved.
 *
 * Implementation and tests adapted from https://www.npmjs.com/package/array-move. This
 * helper was built to replace our reliance on this dependency.
 *
 * @param {any[]} array
 * @param {number} from
 * @param {number} to
 *
 * @return {any[]} Copy of array with the item moved.
 */
export var arrayMove = function (array, from, to) {
    var copiedArray = __spread(array);
    var startIndex = from < 0 ? copiedArray.length + from : from;
    if (startIndex >= 0 && startIndex < copiedArray.length) {
        var endIndex = to < 0 ? copiedArray.length + to : to;
        var _a = __read(copiedArray.splice(from, 1), 1), item = _a[0];
        copiedArray.splice(endIndex, 0, item);
    }
    return copiedArray;
};
//# sourceMappingURL=arrayMove.js.map